/* eslint-disable */
import { StyleSheet } from 'react-native'
import { Fonts } from '../../Themes/'
export default StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'column',

  },
  text: {
    alignSelf: 'center',
    color: '#FFFFFF',
    fontSize: 12,

  },
  button: {
  
    alignSelf: 'center',
    width: 50,
  
  
  
  },
  image: {
    width: 50,
    height: 50
  }
})
